<div class="row">
    <div class="nav-box p-0">
        <div class="navtab">
            <ul class="nav">
                <li *appAuthIf="[CognitoGroup.Registrant, CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier]"
                    class="w-100 pea-green"><a class="w-100 text-truncate"
                        [routerLink]="[{ outlets: { 'navbar-tab': ['order-code', { outlets: {'order-code-tab': ['cart'] } }] } }]"
                        [class.active]="activePath === 'order-code'" id="orderCode">
                        Order a Short Code
                    </a>
                </li>
                <li class="w-100" *appAuthIf="[CognitoGroup.Carrier]">
                    <a class="w-100 text-truncate"
                        [routerLink]="[{ outlets: { 'navbar-tab': ['code-management', { outlets: { 'code-management-tab': ['code-lookup'] } }] } }]"
                        [class.active]="activePath === 'code-management'" id="codeManagement">
                        Code Management
                    </a>
                </li>
                <li class="w-100"
                    *appAuthIf="[CognitoGroup.Registrant, CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier]">
                    <a class="w-100 text-truncate"
                        [routerLink]="[{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-list'] } }] } }]"
                        [class.active]="activePath === 'my-shortcodes'" id="myShortCodes">
                        My Short Codes
                        <span *ngIf="shortCodeCount && shortCodeCount !== 0" id="myShortCodesBadge"
                        class="ms-1 badge rounded-pill">{{shortCodeCount <= 99 ? shortCodeCount : '&nbsp;!&nbsp;'
                            }}</span>
                    </a>
                </li>
                <li *ngIf="showLinkedAccount" class="w-100">
                    <a class="w-100 text-truncate"
                        [routerLink]="[{ outlets: { 'navbar-tab': ['linked-accounts', { outlets: { 'linked-accounts-tab': ['all-short-codes'] } }] } }]"
                        [class.active]="activePath === 'linked-accounts'" id="linkedAccounts">
                        Linked Accounts
                    </a>
                </li>
                <li class="w-100">
                    <a class="w-100 text-truncate"
                        [routerLink]="[{ outlets: { 'navbar-tab': ['my-account', { outlets: { 'my-account-tab': ['account-summary'] } }] } }]"
                        [class.active]="activePath === 'my-account'" id="myAccount">
                        My Account
                    </a>
                </li>
                <li class="w-100"
                    *appAuthIf="[CognitoGroup.Registrant, CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier]">
                    <a i18n class="w-100 text-truncate"
                        [routerLink]="[{ outlets: { 'navbar-tab': ['billing', { outlets: { 'billing-tab': ['view-orders'] } } ] } }]"
                        [class.active]="activePath === 'billing'" id="billing">
                        Billing
                        <span *ngIf="orderCount && orderCount !== 0" id="myOrdersBadge"
                        class="ms-1 badge rounded-pill">{{orderCount <= 99 ? orderCount : '&nbsp;!&nbsp;'
                            }}</span>

                    </a>
                </li>
                @if (brandsEnabled) {
                <li class="w-100">
                    <a class="w-100 text-truncate"
                        [routerLink]="[{ outlets: { 'navbar-tab': ['partner-library', { outlets: { 'partner-library-tab': ['my-brands'] } }] } }]"
                        [class.active]="activePath === 'partner-library'" id="partnerLibrary">
                        My Partners
                        <span *ngIf="partnerCount && partnerCount !== 0" id="myPartnersBadge"
                        class="ms-1 badge rounded-pill">{{partnerCount <= 99 ? partnerCount : '&nbsp;!&nbsp;'
                            }}</span>
                    </a>
                </li>
                }
                <li *appAuthIf="[CognitoGroup.Registrant, CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier, CognitoGroup.ServiceDesk]"
                    class="w-100">
                    <a class="w-100 text-truncate" [routerLink]="[{ outlets: { 'navbar-tab': ['messages'] } }]"
                        [class.active]="activePath === 'messages'" id="messages">
                        Messages
                        <span *ngIf="unreadmessages && unreadmessages !== 0" id="messagesBadge" 
                        class="ms-1 badge rounded-pill">{{unreadmessages <= 99 ? unreadmessages : '&nbsp;!&nbsp;' }}</span>
                    </a>
                </li>
                
                <li class="w-100" *appAuthIf="[CognitoGroup.Carrier]">
                    <a class="w-100 text-truncate" [routerLink]="[{ outlets: { 'navbar-tab': ['suspicious-activity', { outlets: { 'suspicious-activity-tab': ['carrier-reported-activities'] } }] } }]"
                        [class.active]="activePath === 'suspicious-activity'" id="suspicious-activity">
                         Suspicious Activity
                    </a>
                </li>
                <li class="w-100" *appAuthIf="[CognitoGroup.Registrant, CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier]">
                    <a class="w-100 text-truncate" [routerLink]="[{ outlets: { 'navbar-tab': ['reports'] } }]"
                        [class.active]="activePath === 'reports'" id="reports">
                        Reports
                    </a>
                </li>
                <li class="w-100" *appAuthIf="[CognitoGroup.Carrier]">
                    <a i18n class="w-100 text-truncate" [routerLink]="[{ outlets: { 'navbar-tab': ['registry-reports'] } }]"
                        [class.active]="activePath === 'registry-reports'" id="registryReports">
                        Registry Reports
                    </a>
                </li>
                <li class="w-100" *appAuthIf="[CognitoGroup.VettingMonitoring]">
                    <a class="w-100 text-truncate"
                        [routerLink]="[{ outlets: { 'navbar-tab': ['industry-reports', { outlets: { 'industry-reports-tab': ['brand-identification'] } }] } }]"
                        [class.active]="activePath === 'industry-reports'" id="industryReports">
                        Industry Reports
                    </a>
                </li>
                <li class="w-100" *appAuthIf="[CognitoGroup.BIReports]">
                    <a class="w-100 text-truncate" 
                        [class.active]="activePath === 'biReports'" id="biReports" target="_blank" (click)="launchMicrostrategyReports()">
                        BI Reports
                    </a>
                </li>

            </ul>
        </div>
    </div>
    <div class="col-10 p-0">
        <router-outlet name="navbar-tab"></router-outlet>
    </div>
</div>